import Vue from 'vue'
import axios from 'axios'

const initState = {}

export default {
  namespaced: true,
  state: Vue.util.extend({}, initState),
  mutations: {},
  actions: {
    searchCollection({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`podcast/search-collection`, params)
          .then((res) => resolve(res.data))
          .catch((err) => reject(err))
      })
    },
    syncCollection({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('podcast/collection', params)
          .then((res) => resolve(res.data))
          .catch((err) => reject(err))
      })
    },
    getCollection({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`podcast/${params.collectionRecordId}`, { params })
          .then((res) => resolve(res.data.data))
          .catch((err) => reject(err))
      })
    },
    distributeCollection({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`podcast/${params.collectionId}/distribute`, params)
          .then((res) => resolve(res.data.collection))
          .catch((err) => reject(err))
      })
    },
    getComments({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`podcast/video/${id}/comments`)
          .then((res) => resolve(res.data))
          .catch((err) => reject(err))
      })
    },
  },
  getters: {}
}